import classNames from 'classnames/bind';
import { Button } from 'antd';
import { motion, Variants } from 'framer-motion';
import styles from './ProductSection.module.css';
import { LOCALE_LINK } from 'constants/link';
import { getLocaleClassNames, toLocale } from 'utils/locale';
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';
import { useRouter } from 'next/router';

const cx = classNames.bind(styles);

const cardVariants: Variants = {
  offscreen: {
    opacity: 0,
  },
  onscreen: {
    opacity: 1,
    transition: {
      type: 'spring',
      bounce: 0.1,
      duration: 1,
    },
  },
};

function ProductSection() {
  const router = useRouter();
  const { locale } = router;

  const { t } = useTranslation('business');
  return (
    <motion.section
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true }}
      id="product"
    >
      <motion.div variants={cardVariants} className={cx('container')}>
        <section className={cx('content-wrapper')}>
          <h1>{t('merchandise')}</h1>
          <h2>
            <Trans
              i18nKey={t('merchandise-description')}
              components={{
                br: <br />,
              }}
            />
          </h2>
        </section>
      </motion.div>
      <motion.div
        variants={cardVariants}
        className={cx('container', 'grey-wrapper')}
      >
        <section className={cx('content-wrapper')}>
          <div
            className={cx(
              getLocaleClassNames({ className: 'main-image', locale })
            )}
          />
          <div className={cx('image-container')}>
            <div className={cx('content-left')}>
              <div className={cx('left-image')} />
            </div>
            <div className={cx('content-right')}>
              <div className={cx('right-image')} />
            </div>
          </div>
          <div className={cx('license-container')}>
            <h1>{t('merchandise-and-licensing')}</h1>
            <p>
              <Trans
                i18nKey={t('merchandise-and-licensing-description')}
                components={{
                  br: <br />,
                }}
              />
            </p>
            <Button type="primary" shape="round">
              <a
                href={LOCALE_LINK['pinkfong-store'][toLocale(locale)]}
                target="_blank"
                rel="noreferrer"
              >
                <Trans i18nKey={t('shop-now')} />
              </a>
            </Button>
          </div>
        </section>
      </motion.div>
    </motion.section>
  );
}

export default ProductSection;
